import { useIsWideDesktop } from "@/hooks/useIsWideDesktop";
import { useIsChatSidePanelOpen } from "@/stores/chat-artifact-panel-store";
import { companyPreviewPanelStore } from "@/stores/company-preview-panel-store";
import { useSyncExternalStore } from "react";

const getIsCompanyPanelBesideChat = (): boolean => {
  const state = companyPreviewPanelStore.getSnapshot();
  return state !== null && !state.modal;
};

/**
 * What stands beside the desktop chat on its right, under the two-column rule
 * (`WIDE_DESKTOP_MIN_WIDTH`): one slot, which the side panel (a document, a
 * table of people) and a company opened from the chat share. On a screen too
 * narrow for three columns, a company opened while the side panel is out is
 * laid over that panel rather than pushing the chat narrower.
 */
export function useChatColumns(): {
  /** The company preview takes its own column: the chat leaves it room. */
  readonly isCompanyPanelDocked: boolean;
  /** A panel holds the second column of a screen that has room for two. */
  readonly isCrowded: boolean;
} {
  const isWide = useIsWideDesktop();
  const isSidePanelOpen = useIsChatSidePanelOpen();
  const isCompanyPanelOpen = useSyncExternalStore(
    companyPreviewPanelStore.subscribe,
    getIsCompanyPanelBesideChat,
  );
  return {
    isCompanyPanelDocked: isCompanyPanelOpen && (isWide || !isSidePanelOpen),
    isCrowded: !isWide && (isSidePanelOpen || isCompanyPanelOpen),
  };
}
